import Component from './component';
Component.defaultProps = {};
export default Component;
